import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import nudgeKeys from 'actions/nudges/queryKeys';
import { useQuery } from '@tanstack/react-query';
import api from 'utils/api';
import filterObject from 'utils/filterObject';
import { getPageOffset } from 'utils/pagination';
function formatNudgeData(item) {
  var _item$nudge, _item$nudge2, _item$nudge3, _item$nudge4, _item$nudge5, _item$nudge6, _filteredScheduledDat, _item$nudge7, _item$nudge8, _item$nudge9, _item$nudge0, _item$nudge1, _item$nudge10;
  var filteredScheduledDates = (_item$nudge = item.nudge) === null || _item$nudge === void 0 || (_item$nudge = _item$nudge.nudgeAction) === null || _item$nudge === void 0 ? void 0 : _item$nudge.filter(function (action) {
    return action.scheduled_date !== null;
  });
  var formattedNudge = {
    id: (_item$nudge2 = item.nudge) === null || _item$nudge2 === void 0 ? void 0 : _item$nudge2.id,
    name: (_item$nudge3 = item.nudge) === null || _item$nudge3 === void 0 ? void 0 : _item$nudge3.name,
    isEnabled: Boolean((_item$nudge4 = item.nudge) === null || _item$nudge4 === void 0 ? void 0 : _item$nudge4.isEnabled),
    goalType: (_item$nudge5 = item.nudge) === null || _item$nudge5 === void 0 ? void 0 : _item$nudge5.goalType,
    audience: (_item$nudge6 = item.nudge) === null || _item$nudge6 === void 0 ? void 0 : _item$nudge6.audience,
    scheduledDate: (filteredScheduledDates === null || filteredScheduledDates === void 0 || (_filteredScheduledDat = filteredScheduledDates[0]) === null || _filteredScheduledDat === void 0 ? void 0 : _filteredScheduledDat.scheduled_date) || undefined,
    targetDate: ((_item$nudge7 = item.nudge) === null || _item$nudge7 === void 0 ? void 0 : _item$nudge7.target_date) || undefined,
    targetOffset: (_item$nudge8 = item.nudge) === null || _item$nudge8 === void 0 ? void 0 : _item$nudge8.target_offset,
    targetOffsetUnit: (_item$nudge9 = item.nudge) === null || _item$nudge9 === void 0 ? void 0 : _item$nudge9.target_offset_unit,
    targetType: (_item$nudge0 = item.nudge) === null || _item$nudge0 === void 0 ? void 0 : _item$nudge0.target_type,
    isTargetDueDate: Boolean((_item$nudge1 = item.nudge) === null || _item$nudge1 === void 0 ? void 0 : _item$nudge1.is_target_due_date),
    nudgeTeamsIds: ((_item$nudge10 = item.nudge) === null || _item$nudge10 === void 0 || (_item$nudge10 = _item$nudge10.nudgeTeam) === null || _item$nudge10 === void 0 ? void 0 : _item$nudge10.map(function (team) {
      return team.team_id;
    })) || undefined
  };
  return filterObject(formattedNudge);
}
export var CONTENT_NUDGES_PER_PAGE = 20;
export var useContentNudgeQuery = function useContentNudgeQuery(_ref) {
  var contentId = _ref.contentId,
    isEnabled = _ref.isEnabled,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? CONTENT_NUDGES_PER_PAGE : _ref$limit,
    _ref$page = _ref.page,
    page = _ref$page === void 0 ? 1 : _ref$page;
  function fetchContentNudges() {
    return _fetchContentNudges.apply(this, arguments);
  }
  function _fetchContentNudges() {
    _fetchContentNudges = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var offset, listQuery, countQuery, _yield$Promise$all, _yield$Promise$all2, nudges, count, items, formattedItems, total;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            offset = getPageOffset({
              page: page,
              itemsPerPage: CONTENT_NUDGES_PER_PAGE
            });
            listQuery = {
              fields: [{
                nudge: ['id', 'name', 'isEnabled', 'goalType', 'audience', 'target_date', 'target_offset', 'target_offset_unit', 'target_type', 'is_target_due_date', {
                  nudgeTeam: ['team_id']
                }, {
                  nudgeAction: ['scheduled_date']
                }]
              }],
              filter: {
                content_id: contentId
              },
              limit: limit,
              start: offset
            };
            countQuery = {
              fields: {
                count: 'COUNT(DISTINCT id)'
              },
              filter: {
                content_id: contentId
              },
              limit: 10000,
              notfound: 0
            };
            _context.next = 1;
            return Promise.all([api('get', '/api/query/nudgeContent', listQuery), api('get', '/api/query/nudgeContent', countQuery)]);
          case 1:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            nudges = _yield$Promise$all2[0];
            count = _yield$Promise$all2[1];
            items = nudges.items;
            formattedItems = items.map(formatNudgeData);
            total = count.items[0].count || 0;
            return _context.abrupt("return", {
              items: formattedItems,
              total: total
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchContentNudges.apply(this, arguments);
  }
  var _useQuery = useQuery({
      queryKey: nudgeKeys.contentNudgeList(contentId, page),
      queryFn: fetchContentNudges,
      enabled: isEnabled
    }),
    data = _useQuery.data,
    result = _objectWithoutProperties(_useQuery, _excluded);
  return _objectSpread(_objectSpread({}, result), {}, {
    items: (data === null || data === void 0 ? void 0 : data.items) || [],
    total: data === null || data === void 0 ? void 0 : data.total
  });
};
export default useContentNudgeQuery;